import { api } from "@api/api";
import { ApiResponse } from "@shared/types";
import { BookCategory } from "@modules/bookCategories/types";
import { ListBookCategoriesQueryFilters } from "./types";

export async function getBookCategoriesService(filters?: ListBookCategoriesQueryFilters): Promise<BookCategory[]> {
  try {
    const { data } = await api.get<ApiResponse<BookCategory>>(`v1/book_category_admin/`, {
      params: {
        page: filters?.page,
        page_size: filters?.perPage,
        ordering: "-id",
        search: filters?.search,
        ids: Array.isArray(filters?.ids) ? filters.ids.join(",") : undefined,
      },
    });
    return data.results;
  } catch (error) {
    console.error("Error fetching book categories:", error);
    throw error;
  }
}
